import
{
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import
{
  AutoQuantityType,
  Cart,
  CartItem,
  CartItemAutoOptionsDTO,
  ShopProductOption,
} from "@dto";
import { Resolutions } from "@resolutions";
import { ValueWithCommaPipe } from "@shared/pipes/value-with-comma.pipe";
import { showAfterSecond } from "../../../../../utils/utilsFunctions";
import { ContactPopupAbstractComponent } from "../contact-popup-abstract/contact-popup-abstract.component";

@Component({
    selector: "app-sub-item-popup",
    templateUrl: "./sub-item-popup.component.html",
    styleUrls: [
        "../contact-popup-abstract/contact-popup-abstract.component.scss",
        "./sub-item-popup.component.scss",
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SubItemPopupComponent extends ContactPopupAbstractComponent
{
  @ViewChild("valueBindingInput")
  private readonly valueBindingInput: ElementRef;
  public subItems: CartItem[] = [];
  private fatherProductId: number;

  public valueBinding: number = 0;
  public selectedHeight: number = 1.0;
  public animation: boolean;
  public loaded = [];
  public parentItem: any;

  public openModal(data: any, imageThumb?: string, disableReload?: boolean): void
  {
    this.popupService.openPopup(this.name, !!disableReload);
    this.showForm = true;
    this.runModalAnimation(true);

    if (data)
    {
      this.subItems = data.subItems;
      this.parentItem = data.parent;
      this.valueBinding = this.subItems[0].quantity;
      this.fatherProductId = data.productId;
    }

    this.changeDetector.detectChanges();
    this.windowRef.blockScroll();
    showAfterSecond(100, this.loaded, this.changeDetector);
  }

  public getActiveOptionFromActiveSubItem(subItem: CartItem): string
  {
    const commaPipe = new ValueWithCommaPipe();
    return `${subItem.product?.width} cm (${commaPipe.transform(subItem.unitPromotionPriceBrutto)} ${this.translate.instant("general.currency")})`
  }

  public closeModal($event?: any, disableReload?: boolean): void
  {
    this.popupService.closePopup(this.name, !!disableReload);
    this.runModalAnimation(false);
    if (
      this.windowRef.getNativeWindowInnerWidth() >= Resolutions.resolutionTablet
    )
    {
      this.showForm = false;
      this.changeDetector.detectChanges();

    }
    else
    {
      this.showForm = false;
      this.changeDetector.detectChanges();
    }

    this.windowRef.unBlockScroll();
    this.loaded["loaded"] = false;
  }

  public trackByIndex(index, item: CartItem): number
  {
    return item.iD;
  }

  public cartItemToggle(cartItem: CartItem): void
  {
    cartItem.active = !cartItem.active;
    this.cartService
      .cartPositionToggle(
        cartItem.parentID === null ? "null" : cartItem.parentID,
        cartItem.iD,
        cartItem.active
      )
      .subscribe((cart: Cart) =>
      {
        this.valueBinding = cartItem.quantity;
        this.changeDetector.detectChanges();
      });
  }

  public cartItemOptionChange(
    cartItem: CartItem,
    option: ShopProductOption
  ): void
  {
    this.cartService
      .cartPositionSwitch(
        cartItem.parentID === null ? "null" : cartItem.parentID,
        cartItem.iD,
        option.iD
      )
      .subscribe((cart: Cart) =>
      {
        this.subItems = this.getSubItemsByProductId(cart.items, cartItem.iD);
        this.valueBinding = cartItem.quantity;
        // this.calculateValueBinding(cartItem);
        this.changeDetector.detectChanges();
      });
  }

  public updateQuantity(product: CartItem, quantity: number): void
  {
    if (product.quantity !== quantity)
    {
      this.isLoading = true;
      this.cartService
        .setNumberOfElementInCart(
          this.fatherProductId === null ? "null" : this.fatherProductId,
          product.iD,
          quantity
        )
        .subscribe((cart: Cart) =>
        {
          this.subItems = this.getSubItemsByProductId(cart.items, product.iD);
          this.isLoading = false;
          this.selectedHeight = quantity;
          this.changeDetector.detectChanges();
        });
    }
  }

  public isObszycie(subItem: CartItem): boolean
  {
    return subItem.product.code == "UK-OBS-OBSZYCIE.WEWNETRZNE_SI";
  }

  private getSubItemsByProductId(
    cartItems: CartItem[],
    productId: number
  ): CartItem[]
  {
    let subItems = [];
    cartItems.forEach((el) =>
    {
      const x = el.subItems.filter((elx: CartItem) => elx.iD === productId);
      if (x.length > 0)
      {
        subItems = el.subItems;
      }
    });
    return subItems;
  }

  public toggleOrderAllBinding(subItem: CartItem, parentItem: CartItem): void
  {
    if (!this.isSelectedObszycieAll(subItem))
    {
      this.autoQuantityChange(
        subItem,
        parentItem.product.familyCode.includes("CH-") ? 3 : 4
      );
    } else
    {
      this.autoQuantityChange(subItem, 1);
    }
  }

  public autoQuantityChange(subItem: CartItem, autoQuantityType: AutoQuantityType): void
  {
    const autoOptionsDTO = new CartItemAutoOptionsDTO();
    autoOptionsDTO.autoQuantity = autoQuantityType;

    this.cartService.cartBindingChange(subItem.parentID === null ? "null" : subItem.parentID, subItem.iD, autoOptionsDTO)
      .subscribe((res) =>
      {
        this.subItems = this.getSubItemsByProductId(res.items, subItem.iD);
        let returnedSubItem = this.subItems.filter(o => o.iD == subItem.iD)[0];
        let valuePipe = new ValueWithCommaPipe();
        this.valueBindingInput.nativeElement.value = valuePipe.transform(returnedSubItem.quantity, true) + ' ' + returnedSubItem.product.quantityUnit;
        this.changeDetector.detectChanges();
      });
  }

  public updateValueBindingByKeyp(
    subitem: CartItem,
    value,
    $event: KeyboardEvent
  ): void
  {
    if ($event.keyCode == 13)
    {
      $event.preventDefault();
      $event.stopPropagation();
      value = parseFloat(value.replace(/,/gi, "."));
      if (isNaN(value) || value === 0 || subitem.quantity === value)
      {
        const valuePipe = new ValueWithCommaPipe();
        this.valueBindingInput.nativeElement.value = valuePipe.transform(subitem.quantity, true) + ' ' + subitem.product.quantityUnit;
        return;
      }
      this.valueBinding = value;
      this.updateQuantity(subitem, this.valueBinding);
    }
  }

  public isSelectedObszycieAll(cartItem: CartItem): boolean
  {
    return cartItem.selectedAutoQuantityType != 1;
  }

  public updateValueBinding(subItem: CartItem, $event: string): void
  {
    const value = parseFloat($event.replace(/,/gi, "."));
    if (isNaN(value) || value === 0 || subItem.quantity === value)
    {
      const valuePipe = new ValueWithCommaPipe();
      this.valueBindingInput.nativeElement.value = valuePipe.transform(subItem.quantity, true) + ' ' + subItem.product.quantityUnit;
      return;
    }

    if (!this.isSelectedObszycieAll(subItem))
    {
      this.valueBinding = value;
    }
    this.updateQuantity(subItem, this.valueBinding);
  }

  private runModalAnimation(b: boolean): void
  {
    setTimeout(() =>
    {
      this.animation = b;
      this.changeDetector.detectChanges();
    }, 50);
  }
}
